module.exports = __webpack_public_path__ + "assets/img/btn-detail-a694b9d7.png";